import React from 'react';
import { useSelector } from 'react-redux';

import {
  DELETE_CLASS_MODAL_STAGES,
  modalStageSelector,
} from 'features/classCreation';
import DeleteClassModalConfirmationStage from '../DeleteClassModalConfirmationStage';
import DeleteClassModalReasonStage from '../DeleteClassModalReasonStage';
import DeleteClassModalValidationStage from '../DeleteClassModalValidationStage';

export default function DeleteClassModalStageRenderer() {
  const modalStage = useSelector(modalStageSelector);

  switch (modalStage) {
    case DELETE_CLASS_MODAL_STAGES.reason:
      return <DeleteClassModalReasonStage />;
    case DELETE_CLASS_MODAL_STAGES.confirm:
      return <DeleteClassModalConfirmationStage />;
    case DELETE_CLASS_MODAL_STAGES.validation:
      return <DeleteClassModalValidationStage />;
    default:
      return null;
  }
}
